module.exports = __webpack_public_path__ + "img/productBanner3.9a20e409.png";